// AUTO-GENERATED by curriculum-gen/src/gen_thinkcerca_publisher.py — do not edit by hand.
// ThinkCERCA publisher partnership pitch data.

export interface PublisherLesson {
  program: string;
  grade: string;
  theme: string;
  title: string;
  prompt: string;
  plan: string;
  purpose: string;
  importantWords: string[];
  standards: string[];
  templateUrl: string;
}

export interface CurriculumPublisher {
  slug: string;
  name: string;
  tagline: string;
  description: string;
  gradeRange: string;
  lessonCount: number;
  unitCount: number;
  lessons: PublisherLesson[];
  units: string[];
}

export const THINKCERCA_PUBLISHER: CurriculumPublisher = {
  "slug": "thinkcerca",
  "name": "ThinkCERCA",
  "tagline": "Pressto + ThinkCERCA",
  "description": "ThinkCERCA builds the argument — Pressto is where students write it. Together: a complete grades 3–8 argumentative writing program, from CERCA framework to published student work.",
  "gradeRange": "3–8",
  "lessonCount": 30,
  "unitCount": 15,
  "lessons": [
    {
      "program": "ThinkCERCA",
      "grade": "5th",
      "theme": "ThinkCERCA · Catalysts for Change",
      "title": "What Sparked the Voting Rights Movement?",
      "prompt": "The Voting Rights Act of 1965 was one of the most important laws in American history — but it did not happen on its own. Years of organizing, protest, and sacrifice led to that moment.\n\nExplain the causes that sparked the Voting Rights Movement. What people, events, and ideas drove the push for change?\n\nUse evidence from your reading to support your explanation.",
      "plan": "cause-effect",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "voting rights",
        "movement",
        "cause",
        "effect",
        "protest",
        "civil rights",
        "organize",
        "change",
        "evidence",
        "history"
      ],
      "standards": [
        "Informative/Explanatory Writing",
        "W.5.2"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/BgXJbBYJWD"
    },
    {
      "program": "ThinkCERCA",
      "grade": "8th",
      "theme": "ThinkCERCA · Catalysts for Change",
      "title": "Are Individuals or Social Movements the Most Powerful Catalysts for Change?",
      "prompt": "History offers two visions of how change happens: the \"great person\" theory (one visionary leader drives history) and the social movement theory (collective action by ordinary people drives change).\n\nWhich is the more powerful catalyst for change — the individual leader or the social movement? Build an argument grounded in historical evidence.\n\nAddress the counterargument and explain what the evidence reveals about how real change happens.",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "catalyst",
        "change",
        "individual",
        "movement",
        "collective",
        "revolution",
        "argument",
        "evidence",
        "counterargument",
        "history"
      ],
      "standards": [
        "Opinion/Argument Writing",
        "W.8.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/p9RjkBM4ry"
    },
    {
      "program": "ThinkCERCA",
      "grade": "3rd",
      "theme": "ThinkCERCA · Communication",
      "title": "Is Listening More Important Than Speaking?",
      "prompt": "Good communication is about both speaking and listening — but some people say that truly listening is the most important skill of all.\n\nDo you agree that listening is more important than speaking? Write to convince your reader with reasons and examples.\n\nThink about when listening matters most, and when speaking matters most.",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "listening",
        "speaking",
        "communicate",
        "understand",
        "conversation",
        "argue",
        "opinion",
        "evidence",
        "skill",
        "respect"
      ],
      "standards": [
        "Opinion Writing",
        "W.3.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/xMK49L1J08"
    },
    {
      "program": "ThinkCERCA",
      "grade": "6th",
      "theme": "ThinkCERCA · Communication",
      "title": "Does Technology Help or Hurt How We Communicate?",
      "prompt": "Smartphones, social media, and messaging apps have transformed how we talk to each other — some say for better, some say for worse.\n\nDoes technology help or hurt human communication? Take a position and support it with evidence and reasoning.\n\nAddress the counterargument: If someone disagrees with you, what is their strongest point — and how do you respond?",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "technology",
        "communication",
        "digital",
        "connection",
        "argue",
        "evidence",
        "claim",
        "counterargument",
        "social media",
        "impact"
      ],
      "standards": [
        "Opinion/Argument Writing",
        "W.6.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/mWKjeAvj6o"
    },
    {
      "program": "ThinkCERCA",
      "grade": "4th",
      "theme": "ThinkCERCA · Culture",
      "title": "Why Is It Important to Learn About Other Cultures?",
      "prompt": "Our world is made up of thousands of different cultures — each with its own traditions, languages, foods, and ways of life.\n\nWhy is it important to learn about cultures different from your own? Write to convince your reader, using reasons and evidence.\n\nThink about what we gain when we understand others, and what we lose when we don't.",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "culture",
        "tradition",
        "diversity",
        "understand",
        "perspective",
        "respect",
        "global",
        "argue",
        "evidence",
        "community"
      ],
      "standards": [
        "Opinion Writing",
        "W.4.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/DMOJBEbw8N"
    },
    {
      "program": "ThinkCERCA",
      "grade": "7th",
      "theme": "ThinkCERCA · Culture",
      "title": "How Do Ancient and Modern Cultures Compare in Their Views on Justice?",
      "prompt": "Ancient Egypt, ancient Greece, and other civilizations had their own ideas about what justice meant — who deserved rights, how crimes were punished, and who held power.\n\nCompare how an ancient culture and a modern culture define and practice justice. What has changed, and what has stayed the same?\n\nUse evidence from texts you have read to support your analysis.",
      "plan": "compare-contrast",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "justice",
        "ancient",
        "modern",
        "compare",
        "contrast",
        "society",
        "rights",
        "equality",
        "law",
        "culture"
      ],
      "standards": [
        "Informative/Explanatory Writing",
        "W.7.2"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/051Jqk1jKA"
    },
    {
      "program": "ThinkCERCA",
      "grade": "4th",
      "theme": "ThinkCERCA · Environment and Nature",
      "title": "Should We Protect Endangered Animals, Even If It Is Expensive?",
      "prompt": "Some animals are endangered — there are so few left that they could disappear forever. Protecting them costs money and sometimes limits what people can build or do on certain land.\n\nShould we protect endangered animals, even if it is expensive and inconvenient? Write to defend your position.\n\nAddress the counterargument: Some people say the money should be spent on people instead. How do you respond?",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "endangered",
        "protect",
        "conservation",
        "argue",
        "evidence",
        "environment",
        "cost",
        "species",
        "counterargument",
        "ecosystem"
      ],
      "standards": [
        "Opinion Writing",
        "W.4.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/qLd4OqnwO5"
    },
    {
      "program": "ThinkCERCA",
      "grade": "8th",
      "theme": "ThinkCERCA · Environment and Nature",
      "title": "Who Is Most Responsible for Protecting the Ocean?",
      "prompt": "The ocean covers more than 70% of Earth's surface and supports billions of lives — but pollution, overfishing, and climate change are threatening it.\n\nWho bears the greatest responsibility for protecting the ocean: individual people, corporations, or governments? Propose a solution and make a clear argument.\n\nUse evidence about the causes of ocean decline and explain who has the power — and the obligation — to act.",
      "plan": "problem-solution",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "ocean",
        "conservation",
        "responsibility",
        "pollution",
        "climate",
        "solution",
        "argue",
        "evidence",
        "counterargument",
        "policy"
      ],
      "standards": [
        "Opinion/Argument Writing",
        "W.8.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/vXKj7ldwa2"
    },
    {
      "program": "ThinkCERCA",
      "grade": "3rd",
      "theme": "ThinkCERCA · Family and Relationships",
      "title": "How Does Your Family Shape Who You Are?",
      "prompt": "Our families — the people we grow up with — teach us lessons, share traditions, and shape how we see the world.\n\nWrite to explain how your family has shaped who you are. Choose one or two things your family has taught you or shown you, and explain why those things matter to you.\n\nUse specific details and examples.",
      "plan": "description",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "family",
        "tradition",
        "value",
        "teach",
        "relationship",
        "influence",
        "together",
        "lesson",
        "support",
        "shape"
      ],
      "standards": [
        "Informative Writing",
        "W.3.2"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/dXmJ2O14aR"
    },
    {
      "program": "ThinkCERCA",
      "grade": "8th",
      "theme": "ThinkCERCA · Family and Relationships",
      "title": "Is Family Defined by Blood or by Choice?",
      "prompt": "Traditionally, family means the people you are biologically related to. But many people argue that the bonds we choose — close friends, mentors, found families — matter just as much.\n\nIs family defined by blood or by choice? Construct an argument using evidence from literature, research, or real-world examples.\n\nAddress the strongest counterargument and explain why your position holds.",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "family",
        "bond",
        "biology",
        "chosen",
        "relationship",
        "loyalty",
        "belonging",
        "claim",
        "evidence",
        "counterargument"
      ],
      "standards": [
        "Opinion/Argument Writing",
        "W.8.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/YVXwpby40O"
    },
    {
      "program": "ThinkCERCA",
      "grade": "4th",
      "theme": "ThinkCERCA · Freedom and Equality",
      "title": "Should Every Student Have an Equal Opportunity to Learn?",
      "prompt": "Not all schools have the same resources — some have newer buildings, more books, and more teachers. Is that fair?\n\nDo you think every student should have an equal opportunity to learn, no matter where they live? Write to take and defend your position.\n\nUse reasons and evidence to make your argument convincing.",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "equality",
        "opportunity",
        "fairness",
        "education",
        "argue",
        "evidence",
        "rights",
        "resources",
        "counterargument",
        "deserve"
      ],
      "standards": [
        "Opinion Writing",
        "W.4.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/p7N4A6DjRe"
    },
    {
      "program": "ThinkCERCA",
      "grade": "7th",
      "theme": "ThinkCERCA · Freedom and Equality",
      "title": "Is Freedom of Speech Absolute, or Should It Have Limits?",
      "prompt": "The First Amendment protects freedom of speech — but there are long-standing debates about whether some kinds of speech (hate speech, incitement, misinformation) should be limited.\n\nIs freedom of speech absolute, or should it have limits? Construct an argument using constitutional evidence, historical examples, and clear reasoning.\n\nRespond to the strongest counterargument and define where you believe the line should be drawn.",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "freedom of speech",
        "First Amendment",
        "limits",
        "democracy",
        "rights",
        "harm",
        "argue",
        "evidence",
        "counterargument",
        "constitutional"
      ],
      "standards": [
        "Opinion/Argument Writing",
        "W.7.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/0M5jY3LJl2"
    },
    {
      "program": "ThinkCERCA",
      "grade": "5th",
      "theme": "ThinkCERCA · Global Conflict",
      "title": "What Causes Conflicts Between Groups of People?",
      "prompt": "Throughout history and in the world today, groups of people have come into conflict — over land, resources, beliefs, and power.\n\nWhat do you think is the most common cause of conflict between groups of people? Write to explain your thinking and convince your reader.\n\nUse examples from history or current events to support your argument.",
      "plan": "cause-effect",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "conflict",
        "cause",
        "effect",
        "power",
        "resources",
        "belief",
        "argue",
        "evidence",
        "history",
        "resolution"
      ],
      "standards": [
        "Opinion Writing",
        "W.5.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/NqMJRRGJa9"
    },
    {
      "program": "ThinkCERCA",
      "grade": "8th",
      "theme": "ThinkCERCA · Global Conflict",
      "title": "Could World War II Have Been Prevented?",
      "prompt": "World War II was one of the deadliest conflicts in human history. Historians have debated whether the decisions made by world leaders in the 1930s made the war inevitable — or whether it could have been stopped.\n\nDo you think World War II could have been prevented? Build an evidence-based argument using what you know about the causes of the war, the failure of appeasement, and the rise of fascism.\n\nAddress the most powerful counterargument and defend your position.",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "World War II",
        "prevention",
        "appeasement",
        "fascism",
        "inevitable",
        "argument",
        "evidence",
        "counterargument",
        "causes",
        "diplomacy"
      ],
      "standards": [
        "Opinion/Argument Writing",
        "W.8.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/KD8jKqOJXW"
    },
    {
      "program": "ThinkCERCA",
      "grade": "4th",
      "theme": "ThinkCERCA · Individuals and Communities",
      "title": "Can One Person Change a Community?",
      "prompt": "History is full of examples of individuals who made a big difference — from Rosa Parks to Cesar Chavez to ordinary people in your own neighborhood.\n\nDo you believe one person can change a community? Write to convince your reader, using evidence and examples to support your claim.\n\nAddress the counterargument: Some people think change only happens when large groups act together. How would you respond?",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "community",
        "change",
        "individual",
        "impact",
        "action",
        "leader",
        "argue",
        "evidence",
        "example",
        "counterargument"
      ],
      "standards": [
        "Opinion Writing",
        "W.4.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/KeVjN1L4d7"
    },
    {
      "program": "ThinkCERCA",
      "grade": "7th",
      "theme": "ThinkCERCA · Individuals and Communities",
      "title": "Do Individuals Have an Obligation to Give Back to Their Community?",
      "prompt": "Some people believe that if you benefit from a community — its schools, services, and safety — you have a responsibility to give back. Others argue that individuals should be free to pursue their own goals.\n\nDo individuals have an obligation to give back to their community? Build a clear argument with evidence and reasoning.\n\nRespond to the counterargument and explain what civic responsibility means to you.",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "obligation",
        "civic",
        "responsibility",
        "community",
        "individual",
        "contribute",
        "argument",
        "evidence",
        "freedom",
        "counterargument"
      ],
      "standards": [
        "Opinion/Argument Writing",
        "W.7.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/yGLwvW2JkN"
    },
    {
      "program": "ThinkCERCA",
      "grade": "4th",
      "theme": "ThinkCERCA · Money and Needs",
      "title": "Is It Better to Save Money or Spend It?",
      "prompt": "When you have money, you have a choice: save it for later or spend it now. Both have benefits and drawbacks.\n\nDo you think it is better to save money or spend it? Write to take and defend a position, using reasons and evidence.\n\nThink about short-term needs versus long-term goals — and what matters most.",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "save",
        "spend",
        "money",
        "budget",
        "argue",
        "evidence",
        "need",
        "want",
        "decision",
        "goal"
      ],
      "standards": [
        "Opinion Writing",
        "W.4.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/0Z2jnBBj98"
    },
    {
      "program": "ThinkCERCA",
      "grade": "6th",
      "theme": "ThinkCERCA · Money and Needs",
      "title": "Should Entrepreneurs Be Rewarded for the Risks They Take?",
      "prompt": "Entrepreneurs start businesses that can create jobs, solve problems, and drive the economy. But they also take big risks — and some become very wealthy if they succeed.\n\nShould entrepreneurs be rewarded generously for the risks they take? Or are the rewards already too high compared to the risks workers take?\n\nBuild an argument with evidence. Address the counterargument about income inequality and explain your reasoning.",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "entrepreneur",
        "risk",
        "reward",
        "economy",
        "argue",
        "evidence",
        "wealth",
        "inequality",
        "counterargument",
        "innovation"
      ],
      "standards": [
        "Opinion/Argument Writing",
        "W.6.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/PVG48PE4Nv"
    },
    {
      "program": "ThinkCERCA",
      "grade": "5th",
      "theme": "ThinkCERCA · Overcoming Adversity",
      "title": "Does Hardship Make People Stronger?",
      "prompt": "Many people say that facing difficulty — illness, loss, failure — can make a person stronger and more resilient.\n\nDo you agree? Does hardship make people stronger? Write to take and defend a position, using evidence from texts you have read or from real life.\n\nConsider the counterargument: Not everyone who faces hardship comes out stronger. What does this mean for your argument?",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "hardship",
        "adversity",
        "resilience",
        "strength",
        "struggle",
        "overcome",
        "claim",
        "evidence",
        "counterargument",
        "growth"
      ],
      "standards": [
        "Opinion Writing",
        "W.5.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/EmRjDqGw0r"
    },
    {
      "program": "ThinkCERCA",
      "grade": "8th",
      "theme": "ThinkCERCA · Overcoming Adversity",
      "title": "How Does Adversity Shape Character?",
      "prompt": "Literature, history, and psychology suggest that how people respond to adversity often defines who they become.\n\nExplain how adversity shapes character. Use evidence from texts you have read — fiction, nonfiction, biography, or history — to support a clear, specific claim.\n\nWhat factors determine whether adversity builds or breaks a person?",
      "plan": "cause-effect",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "adversity",
        "character",
        "resilience",
        "cause",
        "effect",
        "response",
        "identity",
        "growth",
        "trauma",
        "transformation"
      ],
      "standards": [
        "Informative/Explanatory Writing",
        "W.8.2"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/0gNjoB64YD"
    },
    {
      "program": "ThinkCERCA",
      "grade": "4th",
      "theme": "ThinkCERCA · Personal Identity",
      "title": "What Makes You Who You Are?",
      "prompt": "Your identity is made up of your experiences, your values, your family, and your choices.\n\nWrite to share what makes you who you are. Choose two or three things that have shaped your identity and explain how they have made you the person you are today.\n\nUse specific examples and details from your own life.",
      "plan": "personal-narrative",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "identity",
        "values",
        "experience",
        "character",
        "culture",
        "background",
        "influence",
        "unique",
        "shape",
        "believe"
      ],
      "standards": [
        "Narrative Writing",
        "W.4.3"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/bvpJdbejd8"
    },
    {
      "program": "ThinkCERCA",
      "grade": "6th",
      "theme": "ThinkCERCA · Personal Identity",
      "title": "Is Our Identity Shaped More by Nature or Nurture?",
      "prompt": "Scientists, psychologists, and philosophers have long debated whether who we are comes mostly from our genes (nature) or our environment and experiences (nurture).\n\nTake a position: Is identity shaped more by nature or nurture? Use evidence from what you have read and learned to support your claim.\n\nConsider the counterargument: What would someone who disagrees say, and how would you respond?",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "nature",
        "nurture",
        "genetics",
        "environment",
        "identity",
        "influence",
        "personality",
        "argument",
        "evidence",
        "counterargument"
      ],
      "standards": [
        "Opinion/Argument Writing",
        "W.6.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/3YZwZVgwkb"
    },
    {
      "program": "ThinkCERCA",
      "grade": "3rd",
      "theme": "ThinkCERCA · Policy and Debate",
      "title": "Should Schools Start Later in the Morning?",
      "prompt": "Many students feel tired at school because the school day starts too early.\n\nDo you think schools should start later in the morning? Write to convince your reader, using reasons and evidence to support your claim.\n\nThink about the counterargument: What might someone say who disagrees with you? Be sure to address it.",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "argument",
        "claim",
        "evidence",
        "sleep",
        "schedule",
        "learning",
        "health",
        "policy",
        "counterargument",
        "convince"
      ],
      "standards": [
        "Opinion Writing",
        "W.3.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/dqKwEpEjmx"
    },
    {
      "program": "ThinkCERCA",
      "grade": "7th",
      "theme": "ThinkCERCA · Policy and Debate",
      "title": "Should Social Media Platforms Be Regulated by the Government?",
      "prompt": "Social media platforms shape how billions of people get information, communicate, and form opinions — but they also spread misinformation and harmful content.\n\nShould the government regulate social media platforms? Take a clear position and build your argument using evidence, reasoning, and a response to the strongest counterargument.\n\nAddress the complexity: How do we balance freedom of speech with public safety?",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "regulation",
        "platform",
        "misinformation",
        "free speech",
        "algorithm",
        "policy",
        "accountability",
        "counterargument",
        "evidence",
        "democracy"
      ],
      "standards": [
        "Opinion/Argument Writing",
        "W.7.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/37z4z15Jdx"
    },
    {
      "program": "ThinkCERCA",
      "grade": "4th",
      "theme": "ThinkCERCA · Risk and Gain",
      "title": "Is Taking a Risk Worth It?",
      "prompt": "Taking a risk means trying something when you are not sure it will work out — like trying out for a team, standing up for a friend, or learning something new.\n\nDo you think taking risks is worth it? Write to convince your reader, using examples and reasons.\n\nThink about what we gain from taking risks — and what we might lose.",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "risk",
        "gain",
        "reward",
        "courage",
        "failure",
        "success",
        "argue",
        "evidence",
        "opportunity",
        "decision"
      ],
      "standards": [
        "Opinion Writing",
        "W.4.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/A5DwmB7JOY"
    },
    {
      "program": "ThinkCERCA",
      "grade": "6th",
      "theme": "ThinkCERCA · Risk and Gain",
      "title": "What Made Westward Expansion Both a Risk and a Gain?",
      "prompt": "When pioneers moved west in the 1800s, they risked everything — their safety, their savings, even their lives. Some gained land, opportunity, and a new future. Others lost everything.\n\nExplain the causes and effects of Westward Expansion as a story of both risk and gain. Who risked most? Who gained most? Who paid the price?\n\nUse evidence from your reading to support your explanation.",
      "plan": "cause-effect",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "westward",
        "expansion",
        "pioneer",
        "risk",
        "gain",
        "cause",
        "effect",
        "opportunity",
        "displacement",
        "frontier"
      ],
      "standards": [
        "Informative/Explanatory Writing",
        "W.6.2"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/7oQj37MjYB"
    },
    {
      "program": "ThinkCERCA",
      "grade": "5th",
      "theme": "ThinkCERCA · Social Responsibility",
      "title": "Do We Have a Responsibility to Help People in Need?",
      "prompt": "When we see someone struggling — in our school, our community, or around the world — do we have a responsibility to help?\n\nWrite to take and defend a position: Do people have a social responsibility to help others? Use evidence and reasons to support your argument.\n\nAddress the counterargument: Some people say it is not their responsibility. How do you respond?",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "responsibility",
        "community",
        "help",
        "society",
        "argue",
        "evidence",
        "obligation",
        "compassion",
        "counterargument",
        "fairness"
      ],
      "standards": [
        "Opinion Writing",
        "W.5.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/gVv418VJ0A"
    },
    {
      "program": "ThinkCERCA",
      "grade": "7th",
      "theme": "ThinkCERCA · Social Responsibility",
      "title": "Who Should Be Responsible for Solving Homelessness?",
      "prompt": "Homelessness is a complex problem that affects cities and communities across the United States. Government agencies, nonprofits, businesses, and individuals all play different roles.\n\nWho should take the primary responsibility for solving homelessness — government, businesses, nonprofits, or individuals? Propose a solution and argue for your position.\n\nUse evidence and reasoning to support your claim, and address the most compelling alternative view.",
      "plan": "problem-solution",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "homelessness",
        "solution",
        "responsibility",
        "government",
        "policy",
        "community",
        "argue",
        "evidence",
        "nonprofit",
        "counterargument"
      ],
      "standards": [
        "Opinion/Argument Writing",
        "W.7.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/VY7jQYyjD1"
    },
    {
      "program": "ThinkCERCA",
      "grade": "4th",
      "theme": "ThinkCERCA · Technology and Society",
      "title": "Should Kids Have Smartphones?",
      "prompt": "Many kids want smartphones, but some parents and educators worry about the effects of too much screen time.\n\nShould kids your age have smartphones? Write to take a clear position and convince your reader.\n\nAddress the counterargument: What would someone who disagrees with you say, and how would you respond?",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "smartphone",
        "technology",
        "screen time",
        "argue",
        "opinion",
        "evidence",
        "safety",
        "benefit",
        "counterargument",
        "responsibility"
      ],
      "standards": [
        "Opinion Writing",
        "W.4.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/ybOJ0nZjzR"
    },
    {
      "program": "ThinkCERCA",
      "grade": "8th",
      "theme": "ThinkCERCA · Technology and Society",
      "title": "Should Students Have Fourth Amendment Rights Over Their Digital Privacy at School?",
      "prompt": "Schools increasingly monitor students' online activity — on school devices and sometimes personal phones — in the name of safety. But students argue this violates their right to privacy.\n\nShould students have Fourth Amendment digital privacy rights at school? Build a rigorous argument using constitutional evidence, case law examples, and clear reasoning.\n\nRespond to the strongest counterargument and explain where you draw the line.",
      "plan": "op-ed",
      "purpose": "Argumentative Writing",
      "importantWords": [
        "Fourth Amendment",
        "privacy",
        "digital",
        "rights",
        "school",
        "surveillance",
        "argument",
        "evidence",
        "counterargument",
        "policy"
      ],
      "standards": [
        "Opinion/Argument Writing",
        "W.8.1"
      ],
      "templateUrl": "https://www.joinpressto.com/templates/o8zwVqnj0N"
    }
  ],
  "units": [
    "ThinkCERCA · Catalysts for Change",
    "ThinkCERCA · Communication",
    "ThinkCERCA · Culture",
    "ThinkCERCA · Environment and Nature",
    "ThinkCERCA · Family and Relationships",
    "ThinkCERCA · Freedom and Equality",
    "ThinkCERCA · Global Conflict",
    "ThinkCERCA · Individuals and Communities",
    "ThinkCERCA · Money and Needs",
    "ThinkCERCA · Overcoming Adversity",
    "ThinkCERCA · Personal Identity",
    "ThinkCERCA · Policy and Debate",
    "ThinkCERCA · Risk and Gain",
    "ThinkCERCA · Social Responsibility",
    "ThinkCERCA · Technology and Society"
  ]
};
